import produce from 'immer';
import { CREATE_METHOD_REQUEST, CREATE_METHOD_SUCCESS, CREATE_METHOD_FAILURE, GET_METHOD_REQUEST, GET_METHOD_SUCCESS, GET_METHOD_FAILURE, UPDATE_METHOD_REQUEST, UPDATE_METHOD_SUCCESS, UPDATE_METHOD_FAILURE, LOAD_INTEGRATION_FAILURE, LOAD_INTEGRATION_REQUEST, LOAD_INTEGRATION_SUCCESS, RUN_METHOD_REQUEST, RUN_METHOD_SUCCESS, RUN_METHOD_FAILURE, DELETE_METHOD_FAILURE, DELETE_METHOD_SUCCESS, DELETE_METHOD_REQUEST, } from './constants';
export var initialState = {
    integration: {},
    integration_loading: false,
    integration_error: false,
    method: {},
    method_loading: false,
    method_error: false,
    method_run_loading: false,
    method_run_error: false,
    method_run_result: '',
    method_run_error_content: null,
    loading: false,
    error: false,
};
function methodNewReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CREATE_METHOD_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case CREATE_METHOD_SUCCESS:
                state.method = action.method;
                state.loading = false;
                state.error = false;
                break;
            case CREATE_METHOD_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case UPDATE_METHOD_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case UPDATE_METHOD_SUCCESS:
                state.method = action.method;
                state.loading = false;
                state.error = false;
                break;
            case UPDATE_METHOD_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case DELETE_METHOD_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case DELETE_METHOD_SUCCESS:
                state.method = action.method;
                state.loading = false;
                state.error = false;
                break;
            case DELETE_METHOD_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case GET_METHOD_REQUEST:
                state.method_loading = true;
                state.method_error = false;
                break;
            case GET_METHOD_SUCCESS:
                state.method = action.method;
                state.method_loading = false;
                state.method_error = false;
                break;
            case GET_METHOD_FAILURE:
                state.method_loading = false;
                state.method_error = true;
                break;
            case LOAD_INTEGRATION_REQUEST:
                state.integration_loading = true;
                state.integration_error = false;
                break;
            case LOAD_INTEGRATION_SUCCESS:
                state.integration = action.integration;
                state.integration_loading = false;
                state.integration_error = false;
                break;
            case LOAD_INTEGRATION_FAILURE:
                state.integration_loading = false;
                state.integration_error = true;
                break;
            case RUN_METHOD_REQUEST:
                state.method_run_loading = true;
                state.method_run_error = false;
                state.method_run_error_content = null;
                break;
            case RUN_METHOD_SUCCESS:
                state.method_run_loading = false;
                state.method_run_error = false;
                state.method_run_result = action.response;
                state.method_run_error_content = null;
                break;
            case RUN_METHOD_FAILURE:
                state.method_run_loading = false;
                state.method_run_error = true;
                state.method_run_error_content = action.err || null;
                break;
            default:
                break;
        }
    });
}
export default methodNewReducer;
